import RequestBuilder from 'Resources/RequestBuilder';
import type { MultiSelect } from 'App/components/ListView/ListViewRenderHelpers';
import openModal from 'App/services/Modal';

export default function updateAppointments(rb: RequestBuilder, entity: string, multiSelect: MultiSelect) {
	const opts = {
		customerId: Tools.AppService.getCustomerId(),
		filters: rb,
		hideDate: false,
		entity,
		multiSelect
	};
	return openModal('MultiUpdateAppointmentModal', opts);
}
